import { createContext } from 'react';

import type { BackgroundActivityRegistry } from '@services/backgroundActivityRegistry';
import type { MediaitemUploadService } from '@services/mediaitemUploadService';

export const BackgroundActivityRegistryContext = createContext<BackgroundActivityRegistry | null>(
  null
);
export const MediaitemUploadServiceContext = createContext<MediaitemUploadService | null>(null);
